/** A checkout failure must release the button so the customer can retry. */
export async function checkoutRequest(url: string, body: unknown, timeoutMs = 30000) {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), timeoutMs)
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal,
    })
    const result = await response.json()
    if (!response.ok || !result?.success || !(result.checkoutUrl || (result.clientSecret && result.publishableKey))) {
      return {
        success: false as const,
        error: typeof result?.error === 'string'
          ? result.error
          : 'Checkout is temporarily unavailable. Please try again.',
      }
    }
    return { success: true as const, checkoutUrl: result.checkoutUrl as string | undefined, clientSecret: result.clientSecret as string | undefined, publishableKey: result.publishableKey as string | undefined, sessionId: result.sessionId as string | undefined }
  } catch {
    return {
      success: false as const,
      error: controller.signal.aborted
        ? 'Checkout took too long to respond. Please try again.'
        : 'We could not connect to checkout. Please check your connection and try again.',
    }
  } finally {
    clearTimeout(timeout)
  }
}
